exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disitem[data-v-18db3928]{opacity:.4!important}", ""]);

// exports
